import React from 'react';
import { space } from 'styled-system';
import { styled } from '@teko/ui';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getColor = (props) => {
  const { color, theme } = props;
  return color && ((theme == null ? void 0 : theme.brand[color]) || (theme == null ? void 0 : theme.colors[color])) || color || (theme == null ? void 0 : theme.colors.dark) || "";
};
const StyledText = styled.div(space, (props) => {
  return `
    color: ${getColor(props)};
    font-weight: ${props.fontWeight || "400"};
    font-size: ${props.fontSize || 14}px;
    ${props.lineHeight ? ` line-height: ${props.lineHeight}px;` : ""}
    text-align: ${props.textAlign || "left"};
    overflow: hidden;
    ${props.maxLines ? `text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${props.maxLines};` : ""}
    ${props.textTransform ? `
      text-transform: ${props.textTransform};
    ` : ""}
  `;
});
const Text = (props) => {
  return /* @__PURE__ */ React.createElement(StyledText, __spreadProps(__spreadValues({}, props), {
    maxLines: props.maxLines || 0
  }));
};

export { Text };
